import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import TopNavFour from "../header/TopNavFour";
import InnerBanner from "../page-title/InnerBanner";
import img1 from "../../assets/images/shape/shape_38.svg";
import img2 from "../../assets/images/shape/shape_39.svg";
import SurveyComponent from "./SurveyComponent";
import "./index.css";

const Contact_Us = () => {
  const scrollToOffset = 250; // Number of pixels to scroll down

  useEffect(() => {
    // Calculate the new scroll position
    const newPosition = window.scrollY + scrollToOffset;

    // Scroll to the new position with smooth behavior
    window.scrollTo({ down: newPosition, behavior: "smooth" });
  }, []);

  return (
    <Fragment>
      <div className="main-page-wrapper">
        <Helmet>
          <title>Contact us</title>
        </Helmet>
        <TopNavFour /> 
        <div className="theme-inner-banner">
          <InnerBanner intro="Get in Touch" currpage="Contact Us" />
          <img src={img1} alt="whitecube" className="shapes shape-one" />
          <img src={img2} alt="whitecircle" className="shapes shape-two" />
        </div>
        <div className="app-container" >
        <SurveyComponent />
        </div>
      </div>
    </Fragment>
  );
};

export default Contact_Us;
